import React, { useEffect } from "react";
import { useAppSelector } from "../../../hooks";
import { useCompleteStep } from "../hooks/useCompleteStep";
import PlansPage from "../../PlansPage";
import { CheckCircle } from "lucide-react";

const PlanSelectionStep: React.FC = () => {
  const hasSubscription = useAppSelector((s) => s.subscription.hasSubscription);
  const { complete, onboarding, stepIndex } = useCompleteStep("plan_selection");

  useEffect(() => {
    if (hasSubscription && !onboarding.completedSteps[stepIndex]) {
      complete();
    }
  }, [hasSubscription, onboarding.completedSteps, stepIndex, complete]);

  if (onboarding.completedSteps[stepIndex]) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
        <h3 className="text-xl font-semibold text-gray-800">Plan Selected!</h3>
        <p className="text-gray-500 mt-2">Your subscription is active. Let's continue setting up your business.</p>
      </div>
    );
  }

  return (
    <div>
      <PlansPage
        onSubscriptionComplete={() => {
          complete();
        }}
      />
    </div>
  );
};

export default PlanSelectionStep;
